"use client";

import React from "react";
import { VideoContent } from "@/.storyblok/types/319751/storyblok-components";
import { SbBlokData, storyblokEditable } from "@storyblok/react";

interface VideoPlayerProps {
  blok?: VideoContent & SbBlokData;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ blok }) => {
  if (!blok?.tag) return null;

  const videoSchema = {
    "@context": "https://schema.org",
    "@type": "VideoObject",
    "name": blok.name || blok.title || "",
    "description": blok.description || "",
    "thumbnailUrl": `https://img.youtube.com/vi/${blok.tag}/maxresdefault.jpg`,
    "uploadDate": blok.uploadDate || new Date().toISOString(),
    "duration": blok.duration || "PT0M0S",
    "publisher": {
      "@type": "Organization",
      "name": "TargetDefense",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.targetdefense.com/logo.svg"
      }
    },
    "contentUrl": `https://www.youtube.com/watch?v=${blok.tag}`,
    "embedUrl": `https://www.youtube.com/embed/${blok.tag}`
  };

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(videoSchema)}
      </script>
      <div {...storyblokEditable(blok)} className="video-responsive w-100 rounded-3 shadow overflow-hidden">
        <div className="ratio ratio-16x9">
          <iframe
            src={`https://www.youtube.com/embed/${blok.tag}?iv_load_policy=3&modestbranding=1&playsinline=1&showinfo=0&rel=0&enablejsapi=1&controls=0`}
            title={blok.name || "YouTube video player"}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
    </>
  );
};

export default VideoPlayer;
